import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import {translate} from '../../../../../components/translate/translate.jsx';

const WithoutValueContent = ({ data }) => {
    const withoutData = JSON.parse(data?.graphs?.[0]?.value_data) ?? {};

    useEffect(() => {
        const values = [];
        const labels = [];

        Object.entries(withoutData).forEach(([label, value]) => {
            if (label !== 'ignore') {
                labels.push(translate(label));
                values.push(value);
            }
        });

        GraphicUtils.barChart("withoutValueFields", values, labels, false);
    }, [withoutData]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">Campos sem preenchimento</span>
                <div id="withoutValueFields"></div>
            </div>

            <div className="chart-divisor print-hide"/>
        </>
    );
};

export default WithoutValueContent;